import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { invoiceDisputeActions } from "../../../../store/external/invoice/dispute.reducer";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ConfirmationNotificationModal } from "../../../common/modal/confirmation-modal.component";
import DisputeDetailsView from "./dispute-details-view.component";
import { TABLE_PAGINATION_KEY, DASHBOARD_LABEL, ROUTE_LINK_LOCATION, MODAL_CUSTOM_MESSAGE } from "../../../../constants/external-constants";

import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";

class Dispute extends Component {
    constructor(props){
        super(props);
        this.DisplaySearhBox = this.DisplaySearhBox.bind(this)
        this.state = {
            viewDetailPage: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            displaySearch: false,
            headerTitle: "dispute_management",
            showCreateNewConfirmationModal: false,
            disputeDetailsId: 0,
            statusActiveFilter: 0,
            invoiceAuditId: 0
        }

    }

    componentDidMount() {
        this.props.applyInvoiceDisputeStatusFilter(0);
        this.props.getInvoiceDispute();
        this.setState({
            disputeDetailsId: this.props.detailsDisputeID != undefined ? this.props.detailsDisputeID : 0,
            invoiceAuditId: this.props.invoiceAuditID != undefined ? this.props.invoiceAuditID : 0,
            headerTitle: this.props.detailsDisputeID != undefined ? "dispute_details_view" : "dispute_management"
        });
    }

    componentWillUnmount() {
        this.props.setDefaultInvoiceDispute();
        this.props.getInvoiceDispute(0, true);
    }

    DisplaySearhBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    handleCreateNewAction = () => {
        this.setState({
            showCreateNewConfirmationModal: true,
        })
    }

    handleCreateNew(buttonType) {
        if (buttonType === "ok") {
            this.setState({
                viewDetailPage: true,
                showCreateNewConfirmationModal: false,
                headerTitle: "dispute_details_view"
            });
        } else {
            this.setState({ showCreateNewConfirmationModal: false })
        }

    }
    resizePage = (value) => {
        const { getInvoiceDispute, resizeInvoiceDisputePage } = this.props;
        resizeInvoiceDisputePage(value);
        getInvoiceDispute();
    }

    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractInvoiceDispute();
        }
    };

    applyFilter = (isApply) => {
        const { getInvoiceDispute, applyInvoiceDisputeFilter } = this.props;
        applyInvoiceDisputeFilter(isApply);
        getInvoiceDispute(0);
    }

    handleCloseDetailsPage = () => {
        this.setState({
            viewDetailPage: false,
            headerTitle: "dispute_management",
            disputeDetailsId: 0
        });

        const { getInvoiceDispute } = this.props;
        const { Pagination } = this.props.invoiceDispute.invoiceDisputeItems;

        getInvoiceDispute(Pagination.PageNumber);
    }

    viewDetails(isNew, item, hasLink) {
        if (hasLink && item.InvoiceId && !isNew) {
            window.open(`${ROUTE_LINK_LOCATION.invoiceRouteLink}/${item.InvoiceId}`, "_blank")

        } 
        else if (isNew) {
            this.setState({
                showCreateNewConfirmationModal: true,
            });
        }
        else {
            this.setState({
                headerTitle: "dispute_details_view",
                viewDetailPage: true,
                disputeDetailsId: item.DisputeId
            });
        }
    }
    statusActiveFilter = (statusActiveFilter) => {
        const { getInvoiceDispute, applyInvoiceDisputeStatusFilter } = this.props;
        applyInvoiceDisputeStatusFilter(statusActiveFilter);
        getInvoiceDispute(0);
    }

    loading = () => {
        return (
            <NoSubscription />
        );
    }

    render(){
        const { invoiceDispute, getInvoiceDispute, sortInvoiceDisputeItems, setInvoiceDisputeColSearchStr, addInvoiceDisputeFilter, removeInvoiceDisputeFilter, saveInvoiceDisputeCustomCols } = this.props;
        const { Selected, Available, Default } = this.props.invoiceDispute.invoiceDisputeItems.Columns;
        const { FirstFilter, SecondFilter, ThirdFilter, FourthFilter, TotalFilter } = this.props?.invoiceDispute?.invoiceDisputeItems.StatusFilter || {};
        const statusData = [
            { "label": DASHBOARD_LABEL.total, "value": TotalFilter ?? 0},
            { "label": DASHBOARD_LABEL.open, "value": FirstFilter ?? 0 },
            { "label": DASHBOARD_LABEL.inProgress, "value": SecondFilter ?? 0 },
            { "label": DASHBOARD_LABEL.closed, "value": ThirdFilter ?? 0 },
            { "label": DASHBOARD_LABEL.rejected, "value": FourthFilter ?? 0 }
        ];
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceDisputeDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceDisputeDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceDisputeDashboardRW])

        return(
            <div className="dispute-container invoice-wrapper-container inventory-report-component" >
                <ConfirmationNotificationModal
                    show={this.state.showCreateNewConfirmationModal}
                    message={'Do you want to create new dispute?'}
                    title={'Add New'}
                    handleModal={this.handleCreateNew.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />
                <RequestHeaders headerTitle={this.state.headerTitle} />                
                <div className="request-table data-table fit-width">
                    {
                        (this.state.viewDetailPage || this.props.viewDetailPage) ?
                        <DisputeDetailsView 
                            isMultiContainer={true} 
                            handleClose={this.handleCloseDetailsPage}
                            disputeDetailsId={this.state.disputeDetailsId}
                            invoiceAuditId={this.state.invoiceAuditId}
                            pageRedirection={this.props.viewDetailPage}
                            history={this.props.history}
                        />
                            :<>
                                <DetailsDashboard
                                // Filter Properties
                                data={invoiceDispute.invoiceDisputeItems.TableFilterData}
                                translation={""}
                                addAction={addInvoiceDisputeFilter}
                                removeAction={removeInvoiceDisputeFilter}
                                applyAction={this.applyFilter}

                                //CreateNew Action
                                createNewAction={this.handleCreateNewAction}

                                //View Search Textbox
                                viewSearchAction={this.DisplaySearhBox}

                                //Customize Column
                                firstList={Available}
                                secondList={Selected}
                                defaultList={Default}
                                saveAction={saveInvoiceDisputeCustomCols}

                                //Extract Button
                                extractAction={(e) => this.onClickExtract(e)}

                                //StatusBar
                                statusData={statusData}
                                activeStatusFilter = {this.statusActiveFilter}

                                //Access Type
                                isReadOnly={isReadOnly}
                                isReadAndExtractOnly={isReadAndExtractOnly}
                                isReadAndWrite={isReadAndWrite}
                            >
                             {this.props.invoiceDispute.isInvoiceDisputeLoaded ?
                                <TablePagination  
                                    key={TABLE_PAGINATION_KEY.invoiceDispute}  
                                    classNameWrapper="overflow-auto" 
                                    columns={invoiceDispute.invoiceDisputeItems.Headers}
                                    pageList={invoiceDispute.invoiceDisputeItems.Data}
                                    pages={invoiceDispute.invoiceDisputeItems.Pagination}
                                    rowClickAction={(item, hasLink) => { this.viewDetails(false, item, hasLink) }}
                                    paginationAction={getInvoiceDispute}
                                    onColumnClick={sortInvoiceDisputeItems}
                                    onColumnSearch={() => { getInvoiceDispute(0) }}
                                    onColumnSearchChange={setInvoiceDisputeColSearchStr}
                                    isColSearchShow={this.state.displaySearch}
                                    resizePage={this.resizePage}
                                    totalPage={invoiceDispute.invoiceDisputeItems.Pagination.TotalEntries}
                                    hideStatusIcon={true}
                                        />
                             : this.loading()}
                                </DetailsDashboard>                                     
                        </>
                    }
                   
                </div>                
            </div>
        )
    }
}

export default withRouter(connect(
    state => {
        const { invoiceDispute } = state;

        return {
            invoiceDispute
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceDisputeActions),
        dispatch
    )
)(Dispute));
